import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

// ---------------------------------------------------------

import Grid from '@layout/grid';
import RealtorCard from '@components/realtor-card';
import Select from '@components/select';

// ---------------------------------------------------------

import languageList from '@src/data/language-list.json';

// ---------------------------------------------------------

import styles from '../styles.module.scss';
const { container, search_bar_simple, language_sort, search, card_outer, zero_state } = styles;

// ---------------------------------------------------------

const SearchByAgent = ({ agentData }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [languages, setLanguage] = useState('');
  const [filteredAgents, setFilteredAgents] = useState(agentData || []);
  const top = useRef(null);

  useEffect(() => {
    const filtered = agentData.filter(({ agent }) => {
      const searchTermLowered = searchTerm.toLowerCase();
      return (
        (agent.displayPrimary.toLowerCase().includes(searchTermLowered) ||
          agent.displaySecondary.toLowerCase().startsWith(searchTermLowered) ||
          agent.firstName.toLowerCase().startsWith(searchTermLowered) ||
          agent.lastName.toLowerCase().startsWith(searchTermLowered) ||
          agent.nickname.toLowerCase().startsWith(searchTermLowered) ||
          agent.teamName.toLowerCase().startsWith(searchTermLowered)) &&
        agent.languages.toLowerCase().includes(languages.toLowerCase())
      );
    });
    setFilteredAgents([...filtered]);
  }, [searchTerm, languages]);

  // ---------------------------------------------------------

  const languageOptions = [
    { label: 'All Languages' },
    ...languageList.map((l) => {
      return { label: l.foreignLanguage };
    })
  ];

  const selectLanguage = (el) => {
    if (el === 'All Languages') return setLanguage('');
    setSearchTerm('');
    setLanguage(el);
  };

  // ---------------------------------------------------------
  return (
    <div className={container} ref={top}>
      <div className={search_bar_simple}>
        <div className={language_sort}>
          <Select options={languageOptions} onChange={(el) => selectLanguage(el)} />
        </div>
        <div className={search}>
          <input
            tabIndex="0"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search by agent name"
          />
        </div>
      </div>
      <Grid layout="2">
        {filteredAgents?.map(({ agent }) => {
          return (
            <div className={card_outer} key={agent.agentId}>
              <RealtorCard
                contact={{
                  ...agent,
                  agentLandingPageUrl: `/agent/${agent.agentId}`,
                  displayPhotoUrl: agent.individualPhotoUrl,
                  displayPrimary: agent.name,
                  displaySecondary: agent.teamName || agent.displaySecondary
                }}
                theme="horizontalLarge"
                showLicensedIn
              />
            </div>
          );
        })}
      </Grid>

      {filteredAgents?.length === 0 && (
        <div className={zero_state}>
          <p>No Agents match your search criteria.</p>
        </div>
      )}
    </div>
  );
};

SearchByAgent.propTypes = {
  agentData: PropTypes.array
};

export default SearchByAgent;
